
(function () {
  "use strict";


  // get cart data
  async function getCartData() {
    let cartdata = await fetch("/cart.js", {
      method: "GET",
      credentials: "same-origin",
      headers: {
        "Content-Type": "application/json",
      },
    })
      .then((response) => response.json())
      .then((data) => {
        return data;
      });
    return cartdata;
  }
  
  // add cart item
  async function addItem(key, qty) {
    await fetch("/cart/add.js", {
      method: "POST",
      body: JSON.stringify({
        id: key,
        quantity: qty,
      }),
      credentials: "same-origin",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    })
      .then((data) => {
        document.dispatchEvent(new CustomEvent("cart:build"));        
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  }
  
  // add cart item with properties
  async function addItemWithProperty(data) {
    await fetch("/cart/add.js", {
      method: "POST",
      body: data,
      credentials: "same-origin",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    })
      .then((data) => {
        document.dispatchEvent(new CustomEvent("cart:build"));
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  }
  
  // set cookie
  function setCookie(name,value,days) {
      var expires = "";
      if (days) {
          var date = new Date();
          date.setTime(date.getTime() + (days*24*60*60*1000));
          expires = "; expires=" + date.toUTCString();
      }
      document.cookie = name + "=" + (value || "")  + expires + "; path=/";
    };
  
  // get cookie
  function getCookie(name) {
      var nameEQ = name + "=";
      var ca = document.cookie.split(';');
      for(var i=0;i < ca.length;i++) {
          var c = ca[i];
          while (c.charAt(0)==' ') c = c.substring(1,c.length);
          if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
      }
      return null;
  };

  // remove cookie
  function eraseCookie(name) {
      document.cookie = name +'=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
  };
  
  
  // Free Single Product Modal popup
  function freeSingleProductModal() {
      // resize modal column
      function tbm_modalResize() {
        let tbm_modalRColH = document.querySelector(
          ".tbm_modal-right-col"
        ).offsetHeight;
        document.querySelector(".tbm_modal-left-col").style.height =
          tbm_modalRColH + "px";
      }
      tbm_modalResize();
      window.addEventListener(
        "resize",
        function (event) {
          tbm_modalResize();
        },
        true
      );
  
      let modalContainerDiv = document.querySelector(".tbm_modal-container");
      let tbmModalCookieExpireSet = theme.fspmodal.cookieExpires;
      let tbmModalCookieName = "__tbm_modal_cookie";
  
      function modalContainer(key) {
        if (key == "hide") {
          modalContainerDiv.style.display = "none";
        }
        if (key == "show") {
          modalContainerDiv.style.display = "block";
        }
      }
  
      //{% if settings.tbm_cookie-expires == "-1" %}
      if (theme.fspmodal.cookieExpires == "-1") {
        //Cookies.remove(tbmModalCookieName, { path: "" });
        eraseCookie(tbmModalCookieName);
        console.log("FG modal cookie removed");
      }
  
      // set cookie, show popup
      if (getCookie(tbmModalCookieName) != "1") {
        setTimeout(function () {
          tbm_modalResize();
          //$('.tbm_modal-container').fadeIn(600);
          modalContainer("show");
          tbm_modalResize();
        }, theme.fspmodal.cookieModalDelay);
        //Cookies.set(tbmModalCookieName, "1", {
          //expires: tbmModalCookieExpireSet,
        //});
        setCookie(tbmModalCookieName,1,tbmModalCookieExpireSet)
      } else {
        console.log("FG popup - already visited");
      }
  
      // close modal
      document
        .querySelector(".tbm_modal-close")
        .addEventListener("click", function (e) {
          e.preventDefault();
          modalContainer("hide");
        });
      document
        .querySelector(".tbm_modal-clickable")
        .addEventListener("click", function (e) {
          e.preventDefault();
          modalContainer("hide");
        });
  
      // trigger modal
      document
        .querySelector(".tbm_modal_trigger")
        .addEventListener("click", function (e) {
          e.preventDefault();
          modalContainer("show");
          tbm_modalResize();
        });
  
  
      // get elements
      function elementReady(selector) {
        return new Promise((resolve, reject) => {
          let el = document.querySelector(selector);
          if (el) {
            resolve(el); 
            return
          }
          new MutationObserver((mutationRecords, observer) => {
            // Query for elements matching the specified selector
            Array.from(document.querySelectorAll(selector)).forEach((element) => {
              resolve(element);
              //Once we have resolved we don't need the observer anymore.
              observer.disconnect();
            });
          })
            .observe(document.documentElement, {
              childList: true,
              subtree: true
            });
        });
      }
  
      elementReady('#bayengageEmbedForm form').then((form) => {
        tbm_modalResize();
        form.addEventListener("submit", (event) => {
            // add free product to cart
            var itemData = JSON.stringify({
              quantity: 1,
              id: theme.fspmodal.freeProdId,
              properties: { _modalfree: "true" },
            });
            addItemWithProperty(itemData);
            
            setTimeout(function () {
              document.getElementById("HeaderCartTrigger").click();
            }, 2000);
      
            // close modal
            setTimeout(function () {
              modalContainer("hide");
            }, 5000);
        });
      });      
  };
  
  // wholesale info modal popup
  function wholesaleInfoModal() {
    let wimContainerDiv = document.querySelector(".wim-container");
    let wimCookieExpires = theme.wim.cookieExpires;
    let wimCookieName = "__wim_cookie";
  
    function wimContainer(key) {
      if (key == "hide") {
        wimContainerDiv.style.display = "none";
      }
      if (key == "show") {
        wimContainerDiv.style.display = "block";
      }
    }
  
    if (theme.wim.cookieExpires == "-1") {
      //Cookies.remove(wimCookieName, { path: "" });
      eraseCookie(wimCookieName);
      //console.log("WIM cookie removed");
    }
  
    // set cookie, show popup
    if (getCookie(wimCookieName) != "1") {
      setTimeout(function () {
        wimContainer("show");        
      }, theme.wim.cookieModalDelay);
      //Cookies.set(wimCookieName, "1", {
        //expires: wimCookieExpires,
      //});
      setCookie(wimCookieName,1,wimCookieExpires)
    } else {
      //console.log("WIM - already visited");
    }
  
    // close modal
    document
      .querySelector(".wim-close-msg")
      .addEventListener("click", function (e) {
        e.preventDefault();
        wimContainer("hide");
      });
    document
      .querySelector(".wim-close-btn")
      .addEventListener("click", function (e) {
        e.preventDefault();
        wimContainer("hide");
      });
    document
      .querySelector(".wim-clickable")
      .addEventListener("click", function (e) {
        e.preventDefault();
        wimContainer("hide");
      });
  };



  function DOMready(callback) {
    if (document.readyState != "loading") callback();
    else document.addEventListener("DOMContentLoaded", callback);
  }
  
  DOMready(function () {
  
    if (theme.fspmodal.isEnabled) {
      freeSingleProductModal();
    }
    if (theme.wim.isEnabled) {
      if (window.location.pathname.indexOf(theme.wim.trigerContains) !== -1) {
        wholesaleInfoModal();  
      }      
    } 
  
  });

})();